import { CheckboxFormProvider } from "components/CheckboxFormProvider";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

interface MonthsCheckboxFieldProps {
  name: string;
  label: string;
  required?: boolean;
}

export const MonthsCheckboxField: FC<MonthsCheckboxFieldProps> = ({
  name,
  label,
  required = false,
}) => {
  const { formState } = useFormContext();
  const { errors } = formState;

  const fieldError = name.split(".").reduce((obj: any, key) => obj?.[key], errors);

  return (
    <div className="mt-4">
      <fieldset
        className={
          fieldError ? "rounded-md border border-red-300 p-3" : ""
        }
      >
        <legend className="text-sm font-medium text-gray-700">
          {label} {required && "*"}
        </legend>
        {fieldError && (
          <p className="mb-2 text-sm text-red-600">
            {(fieldError as any)?.message || "Välj minst en månad"}
          </p>
        )}
        <div className="mt-2 grid grid-cols-2 gap-x-6 gap-y-2 sm:grid-cols-3">
          {/* First column: January-April */}
          <div className="space-y-2">
            <CheckboxFormProvider name={`${name}.january`} label="Januari" />
            <CheckboxFormProvider name={`${name}.february`} label="Februari" />
            <CheckboxFormProvider name={`${name}.march`} label="Mars" />
            <CheckboxFormProvider name={`${name}.april`} label="April" />
          </div>

          {/* Second column: May-August */}
          <div className="space-y-2">
            <CheckboxFormProvider name={`${name}.may`} label="Maj" />
            <CheckboxFormProvider name={`${name}.june`} label="Juni" />
            <CheckboxFormProvider name={`${name}.july`} label="Juli" />
            <CheckboxFormProvider name={`${name}.august`} label="Augusti" />
          </div>

          {/* Third column: September-December */}
          <div className="space-y-2">
            <CheckboxFormProvider name={`${name}.september`} label="September" />
            <CheckboxFormProvider name={`${name}.october`} label="Oktober" />
            <CheckboxFormProvider name={`${name}.november`} label="November" />
            <CheckboxFormProvider name={`${name}.december`} label="December" />
          </div>
        </div>
      </fieldset>
    </div>
  );
};
